/** @file toRenderParams: a RenderQuery as string query parameters (arrays as comma lists). */
import type { RenderQuery } from '../types/rest';

/** The keys in `RenderQuery` order, so the same query always gives the same URL (the server caches by it). */
const KEYS = ['clip', 'frames', 'directions', 'variants', 'format', 'scale', 'compare', 'overlay', 'pitch', 'layout', 'labels'] as const satisfies readonly (keyof RenderQuery)[];

/** `{ frames: [0, 8], directions: 16 }` → `{ frames: '0,8', directions: '16' }`; absent keys stay absent. */
export function toRenderParams(q: RenderQuery): Record<string, string> {
  const out: Record<string, string> = {};
  for (const key of KEYS) {
    const value = q[key];
    if (value !== undefined) out[key] = Array.isArray(value) ? value.join(',') : String(value);
  }
  return out;
}
